import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';

import ScrollToTopRoute from '../../shared/components/hocs/ScrollToTopRoute';

const BaseApp = (props) => {
    return (
        <Provider store={props.store}>
            <Suspense fallback={<div className="d-none">Changing Languages...</div>}>
                <BrowserRouter>
                    <ScrollToTopRoute>
                        <div>{renderRoutes(props.routes)}</div>
                    </ScrollToTopRoute>
                </BrowserRouter>
            </Suspense>
        </Provider>
    );
};

export default hot(module)(BaseApp);
